import { extraInfo } from '@/mocks/wedding';

export default function ExtraInfoSection() {
  return (
    <section className="section alt" id="extra">
      <span className="panel-accent" aria-hidden="true" data-parallax="0.55" data-corner="bl">
        07
      </span>
      <div className="section-head">
        <p className="stamp" data-reveal>
          07 — 추가 안내
        </p>
        <h2 data-reveal>
          편안한 하루가 되도록
          <br />
          <em className="accent">미리</em> 알려드려요
        </h2>
        <p className="sub" data-reveal>
          식사와 답례품, 셔틀과 주차까지. 예식 당일 헤매지 않도록 정리해 두었습니다.
        </p>
      </div>

      <div className="info-cols">
        {extraInfo.map((col) => (
          <article className="info-col" key={col.title} data-reveal>
            <h3>{col.title}</h3>
            <ul>
              {col.items.map((it) => (
                <li key={it}>{it}</li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </section>
  );
}